import config from './config.xml';
import tasks from './tasks.json';
import annotation from './annotations/1.json';

export const Buckets = { config, tasks, annotation };
